export function EquipmentSparePartFactory() {
    return function EquipmentSparePart() {
        this.id = null;
        this.name = null;
    };
}
